import { EditorState } from '../types';
import { unselectItemForCrop } from './item-cropping';

/**
 * 줌 영역 편집 모드 진입 — 캔버스에 bbox 오버레이(ZoomRegionOverlay)를 띄운다.
 * crop 모드와 상호 배타라 진입 시 crop 을 해제한다.
 */
export const selectItemForZoomRegion = ({
  state,
  itemId,
}: {
  state: EditorState;
  itemId: string;
}): EditorState => {
  return {
    ...unselectItemForCrop(state),
    itemSelectedForZoomRegion: itemId,
  };
};

export const unselectItemForZoomRegion = (state: EditorState): EditorState => {
  if (!state.itemSelectedForZoomRegion) {
    return state;
  }

  return {
    ...state,
    itemSelectedForZoomRegion: null,
  };
};
